import api from './api.service'

export const documentationAliasService = {
    list,
    get,
    save,
    update,
    _delete,
    importCSV
};

const BASE_URL = '/documentationAlias'

function list(max) {
    return api.get(BASE_URL, {max : max || 1000})
}

function get(id) {
    return api.get(BASE_URL + "/" + id)
}

function save(documentationAlias) {
    return api.post(BASE_URL, documentationAlias)
}

function update(id, documentationAlias) {
    return api.put(BASE_URL + "/" + id, documentationAlias)
}

function _delete(id) {
    return api.delete(BASE_URL + "/" + id)
}

function importCSV(data) {
	return api.post(BASE_URL + "/importCSV", data)
}
